import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { TrackingMapsModule } from '../../ui-kit/tracking-maps/tracking-maps.module';
import { ExpansionMapComponent } from './expansion-map.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { SvgIconModule } from '../../ui-kit';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    TrackingMapsModule,
    MatExpansionModule,
    TranslateModule.forChild({}),
    SvgIconModule,
  ],
  exports: [ExpansionMapComponent],
  declarations: [ExpansionMapComponent],
})
export class ExpansionMapModule {}
